/// <amd-module name="Feed/Legacy/Actions/FeedSettings/ViewNameValidator" />
import * as Utils_String from "VSS/Core/Util/String";

import { FeedSettingsComponents } from "Feed/Common/Constants/Constants";
import { FeedView } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";
import { ValidateViewName } from "Feed/Common/Utils/Validator";
import { IValidationResult } from "Feed/Legacy/Actions/FeedSettings/ValidationHandler";
import { IFeedSettingsState } from "Feed/Legacy/Components/Settings/IFeedSettingsState";

export class ViewNameValidator {
    /**
     * originalViewName -- null if adding a new view.  If editing a view, the original name of the view being edited.
     */
    public static GetValidationResult(
        state: IFeedSettingsState,
        viewName: string,
        originalViewName: string
    ): IValidationResult {
        const validationResult: IValidationResult = {
            componentKey: FeedSettingsComponents.viewName,
            errorMessage: null
        };

        if (viewName === "") {
            return validationResult;
        }

        if (originalViewName != null && viewName === originalViewName) {
            return validationResult;
        }

        const isValid: boolean = ValidateViewName(viewName);
        if (!isValid) {
            validationResult.errorMessage =
                PackageResources.FeedEditDialogReleaseViews_ReleaseViewNameErrorAlphanumeric;
            return validationResult;
        }

        const viewWithSameNameExists: boolean = state.views.some((view: FeedView) => {
            return Utils_String.equals(view.name, viewName, true);
        });

        if (viewWithSameNameExists) {
            validationResult.errorMessage = Utils_String.format(
                PackageResources.Error_FeedSettings_ViewNameAlreadyExists,
                viewName
            );
            return validationResult;
        }
    }
}
